module.exports = __webpack_public_path__ + "img/bg1_wind.955b1680.jpg";